/**
 * Active RecordDefs
 * 
 * @created: MAZito - 8-Abr-2021
 */
import { cloned } from '@/helpers'

export let 
  recordDefsHash = {},
  recordDefsList = [];

export function restoreRecordDefs() {
  /**
   * Load all the account the RecordDefs and builds a List and a Hash
   */
  let 
    request = Idb.get("account").then((result) => {
      let account = result.value
      console.log('record-defs.js: defs retrieved from iDB', account.defs)
      
      recordDefsList = (account.defs || []).map((t) => {
        t.account_id = account.id;
        recordDefsHash[t.id] = cloned(t)
        return { 
          id: t.id, 
          master_id: t.master_id, 
          state: t.state,
          title: `${t.title} (v${t.version}) (${t.state})` 
        }
      })
    })
  // Pre iDB
  // recordDefsList = (account.defs || []).map((t) => {
  //   t.account_id = account.id;
  //   recordDefsHash[t.id] = cloned(t)
  //   return { 
  //     id: t.id, 
  //     master_id: t.master_id, 
  //     state: t.state,
  //     title: `${t.title} (v${t.version}) (${t.state})` 
  //   }
  // })
}
